// extracted by mini-css-extract-plugin
module.exports = {"advertising-position":"_11ZdMslfOt","page-main":"nXIyyPAdU-","page-header":"xOfridk4z0","btn-style":"_9KEaAsm0Ie","img-box":"_68WjA0a5kw","search-icon":"_3GsS6YQ7Bp"};